<template>
  <div id="comment">
    <div class="comment-input" @click="show = true">写下你的留言</div>

    <div class="comment-list" v-if="comments.length">
      <div class="comment-list-title">精选留言</div>

      <div class="comment-list-container">
        <div
          class="comment-item"
          v-for="(item, index) in comments"
          :key="index"
        >
          <div class="commenter">
            <div class="commenter-userinfo">
              <img
                src="@/assets/iconUserPhonto.png"
                alt=""
                class="commenter-avatar"
              />
              <p class="commenter-realname">{{ item.realname }}</p>
            </div>
            <div class="commenter-content">{{ item.content }}</div>
            <div class="commenter-reply" v-if="item.answer">
              <div class="commenter-replyer">
                <img
                  src="@/assets/iconTeacPhonto.png"
                  alt=""
                  class="commenter-replyer-avatar"
                />
                <p class="commenter-replyer-name">老师</p>
              </div>
              <div class="commenter-replayer-content">{{ item.answer }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="show"
      round
      closeable
      close-icon-position="top-left"
      position="bottom"
      safe-area-inset-bottom
    >
      <div class="comment-box">
        <div class="comment-box-header">
          <div class="comment-box-title">写留言</div>
          <div class="comment-box-submit" @click="onSubmit">提交</div>
        </div>

        <div class="comment-box-textarea">
          <van-field
            v-model="myComment"
            rows="4"
            autosize
            type="textarea"
            placeholder="留言审核通过后，将在页面展示。"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { comment, getComments } from "@/api/comment";
import { Toast } from "vant";

export default {
  name: "Comment",
  props: {
    cid: {
      type: String,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      show: false,
      myComment: "",
      comments: [],
    };
  },

  methods: {
    onSubmit() {
      const that = this;
      if (that.myComment) {
        that.show = false;
        let post_data = {
          cid: that.cid,
          content: that.myComment,
        };

        comment(post_data)
          .then((res) => {
            console.log(res);
            // 自定义加载图标
            Toast.success({
              message: res.msg,
              forbidClick: true,
              onClose: () => {},
            });
          })
          .catch((rej) => {
            console.log(rej);
          });
      } else {
        Toast.fail("留言不能为空");
      }
    },
  },
  mounted() {
    const that = this;
    let post_data = {
      cid: this.cid,
    };
    getComments(post_data)
      .then((res) => {
        console.log("res", res);
        that.comments = res.data;

        that.$nextTick(() => {
            let commentBox = document.querySelector(".comment-list-container");
            let height = document.querySelector('#detail').offsetHeight - commentBox.offsetTop;
            // console.log(document.querySelector('#detail').offsetHeight);
            // console.log(commentBox.offsetTop);
            // console.log(document.querySelector('#video').offsetHeight);
            commentBox.style.height = height + "px";
            commentBox.style.overflowY = 'scroll';
          });
      })
      .catch((rej) => {
        console.log("rej", rej);
      });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
#comment {
  padding-bottom: 20px;
  .comment-input {
    width: 680px;
    height: 72px;
    border-radius: 20px;
    background-color: #fff;
    line-height: 72px;
    padding-left: 28px;
    color: #888;
    border: 1px solid #f1f0f4;
    margin: 24px auto;
  }
  .comment-list {
    width: 680px;
    margin: 20px auto;

    .comment-list-title {
      padding: 20px 0;
      border-bottom: 2px solid #eee;
    }

    .comment-list-container {
      min-height: 30vh;
      .comment-item {
        margin-bottom: 40px;
        .commenter {
          .commenter-userinfo {
            display: flex;
            align-items: center;
            color: #99989b;
            margin: 20px 0;

            .commenter-avatar {
              width: 36px;
              height: 36px;
              margin-right: 12px;
            }
          }

          .commenter-content {
            padding-left: 48px;
            margin-bottom: 20px;
          }
          .commenter-reply {
            padding-left: 48px;

            .commenter-replyer {
              display: flex;
              align-items: center;
              color: #99989b;
              margin: 20px 0;
              .commenter-replyer-avatar {
                width: 36px;
                height: 36px;
                margin-right: 12px;
              }
            }
            .commenter-replayer-content {
              padding-left: 48px;
            }
          }
        }
      }
    }
  }

  .comment-box {
    padding-bottom: 64px;
    .comment-box-header {
      height: 96px;
      line-height: 96px;
      position: relative;
      .comment-box-title {
        width: 100%;
        text-align: center;
      }
      .comment-box-submit {
        position: absolute;
        color: #fff;
        background-color: #fc5b21;
        border-radius: 16px;
        width: 118px;
        height: 56px;
        line-height: 56px;
        right: 20px;
        top: 20px;
        text-align: center;
      }
    }
  }
}
</style>